import { render, staticRenderFns } from "./MakeCafe.vue?vue&type=template&id=06c8ee72"
import script from "./MakeCafe.vue?vue&type=script&lang=js"
export * from "./MakeCafe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports